export const TIDS = {
  nav: {
    home: "nav-home",
    book: "nav-book",
    fleet: "nav-fleet",
    adminLogin: "nav-admin-login",
    callBtn: "nav-call-btn",
    qrBtn: "nav-qr-btn",
  },
  hero: {
    ctaBook: "hero-cta-book",
    ctaCall: "hero-cta-call",
  },
  booking: {
    riderName: "booking-rider-name",
    riderMobile: "booking-rider-mobile",
    riderEmail: "booking-rider-email",
    pickup: "booking-pickup",
    dropoff: "booking-dropoff",
    pickupType: "booking-pickup-type",
    pickupTime: "booking-pickup-time",
    passengers: "booking-passengers",
    service: "booking-service",
    payment: "booking-payment",
    notes: "booking-notes",
    submit: "booking-submit",
    distance: "booking-distance",
  },
  confirmation: {
    reference: "confirmation-reference",
    payNow: "confirmation-pay-now",
    back: "confirmation-back",
  },
  admin: {
    email: "admin-login-email",
    password: "admin-login-password",
    submit: "admin-login-submit",
    logout: "admin-logout",
    sidebarBookings: "sidebar-bookings",
    sidebarDrivers: "sidebar-drivers",
    sidebarServices: "sidebar-services",
    sidebarStaff: "sidebar-staff",
    sidebarPayments: "sidebar-payments",
    sidebarAudit: "sidebar-audit",
    sidebarReports: "sidebar-reports",
  },
};
